import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var BNPLMobileFormHeader = function BNPLMobileFormHeader(_ref) {
  var title = _ref.title,
    hideBack = _ref.hideBack,
    updateShowPopUp = _ref.updateShowPopUp,
    isOtpStep = _ref.isOtpStep;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-white pt-[10px] pb-[5px] px-[5%]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between pb-4 mb-[10px]"
  }, !hideBack && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return window.history.back();
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "en:transform en:[transform:rotateY(180deg)]",
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/mobileBackBlueArr.svg"
  }))), !isOtpStep ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", {
    className: "text-base font-bold leading-6 text-primary-old"
  }, title || '')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-8 h-4"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("button", {
    className: "text-[#3C56D4] text-xs font-bold leading-4  border-none bg-transparent",
    onClick: function onClick() {
      return updateShowPopUp(true);
    }
  }, t("cancel", {
    ns: "web_checkout_finance"
  }))))));
};
export default BNPLMobileFormHeader;